import { Switch } from 'antd';

function ToggleSwitch(props) {
  return (
    <Switch
      {...props}
    />
  );
}

export default ToggleSwitch;
